import { React, useState, useEffect } from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Features from "components/other-cards/ServiceFeature.js";
import FooterCard from "components/footers/PageFooter";
import PageHeader from "components/headers/PageHeader";
import ServiceTiles from "components/other-cards/ServiceTiles";
import EnquiryCard from "components/home-cards/EnquiryCard";

import CarIconImage from "images/car.png";
import VisaIconImage from "images/visa.png";
import CruiseIconImage from "images/cruise.png";
import FlightIconImage from "images/flight.png";
import ResortIconImage from "images/resort.png";
import HotelIconImage from "images/hotel.png";
import TourIconImage from "images/tour.png";
import PassportIconImage from "images/passport.png";
import InsuranceIconImage from "images/insurance.png";

const API_URL = process.env.REACT_APP_IS_PROD == "true" ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_DEV



export default () => {

  const [services, setServices] = useState([]);

  const dummyData = [
    {
      id: 1,
      name: "Passport Assist",
      icon: PassportIconImage,
      description: "Helping you with passport applications and renewals.",
    },
    {
      id: 2,
      name: "Tour Packages",
      icon: TourIconImage,
      description: "Customized travel packages to your dream destinations.",
    },
    {
      id: 3,
      name: "Hotel Bookings",
      icon: HotelIconImage,
      description: "Affordable and luxurious hotel reservations.",
    },
    {
      id: 4,
      name: "Resort Stays",
      icon: ResortIconImage,
      description: "Exclusive resort stays for a relaxing experience.",
    },
    {
      id: 5,
      name: "Flight Bookings",
      icon: FlightIconImage,
      description: "Seamless flight ticket bookings at competitive prices.",
    },
    {
      id: 6,
      name: "Travel Insurance",
      icon: InsuranceIconImage,
      description: "Comprehensive travel insurance plans for peace of mind.",
    },
    {
      id: 7,
      name: "Cruise Packages",
      icon: CruiseIconImage,
      description: "Memorable cruise vacations to stunning destinations.",
    },
    {
      id: 8,
      name: "Car Rentals",
      icon: CarIconImage,
      description: "Convenient car rental services for your travel needs.",
    },
    {
      id: 9,
      name: "Visa Services",
      icon: VisaIconImage,
      description: "Expert assistance with visa applications and processing.",
    },
  ];

  useEffect(() => {
    document.body.style.overflow = 'auto'
  });

  useEffect(() => {
    const fetchServices = async () => {
      try {

        const response = await fetch(`${API_URL}/web/services/list-services`, {
          headers: {
            'X-API-Key': process.env.REACT_APP_ACCESS_API_KEY // Add API key to headers
          }
        });
        const result = await response.json();

        if (result.header.resCode === 200 && result.data.length > 0) {
          setServices(result.data);
        }
      } catch (err) {
        console.error(err.message);
      }
    };

    fetchServices();
  }, []);

  return (
    <AnimationRevealPage>
      <PageHeader pageName="Traviator Services" titleName="" />
      <br /><br />
      <ServiceTiles cards={services} />
      <br /><br /><br /><br />
      <Features isButton={false} subheading="Why Choose us ?" heading="Best Services" />
      <EnquiryCard />
      <FooterCard />
    </AnimationRevealPage>
  )
};
